import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Realisations() {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/projects")
            .then(({ data }) => setProjects(data))
            .catch(() => setProjects([]))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24" data-testid="realisations-page">
            <Reveal>
                <span className="overline">Réalisations</span>
                <h1 className="mt-6 font-serif text-6xl md:text-7xl lg:text-8xl font-light text-brand-ink leading-[1.02]">
                    Nos projets
                    <span className="italic block">livrés.</span>
                </h1>
            </Reveal>

            {loading ? (
                <p className="mt-20 text-brand-sageDark">Chargement…</p>
            ) : projects.length === 0 ? (
                <Reveal delay={120}>
                    <div className="mt-16 border border-brand-border bg-brand-bgalt p-10 md:p-16 text-center max-w-3xl mx-auto">
                        <p className="font-serif text-3xl md:text-4xl text-brand-ink italic font-light leading-relaxed">
                            « Nos premiers chantiers s'écrivent. »
                        </p>
                        <p className="mt-8 text-lg text-brand-sageDark font-light leading-relaxed">
                            Nos premiers projets sont en préparation. Cette page accueillera bientôt nos rénovations
                            livrées, photographiées et documentées avec soin.
                        </p>
                        <Link
                            to="/devis"
                            className="mt-10 inline-flex items-center gap-3 px-9 py-5 bg-brand-ink text-brand-bg text-sm uppercase tracking-[0.22em] hover:bg-brand-sage transition-colors"
                        >
                            Devenir l'un de nos premiers projets
                        </Link>
                    </div>
                </Reveal>
            ) : (
                <div className="mt-20 grid md:grid-cols-2 gap-8 md:gap-12">
                    {projects.map((p, idx) => (
                        <Reveal key={p.id} delay={idx * 60}>
                            <Link to={`/realisations/${p.slug}`} className={`block group ${idx % 3 === 0 ? "md:col-span-2" : ""}`}>
                                <div className={`hover-zoom ${idx % 3 === 0 ? "aspect-[16/8]" : "aspect-[4/3]"} bg-brand-bgalt`}>
                                    {(p.after_image || p.gallery?.[0]) && (
                                        <img src={p.after_image || p.gallery[0]} alt={p.title} className="w-full h-full object-cover" />
                                    )}
                                </div>
                                <div className="mt-5 flex items-end justify-between">
                                    <div>
                                        {p.year && <span className="overline">{p.year}</span>}
                                        <h3 className="font-serif text-2xl md:text-3xl text-brand-ink mt-2 group-hover:text-brand-sage transition-colors">{p.title}</h3>
                                        <p className="text-sm text-brand-sageDark mt-1">
                                            {[p.location, p.surface, p.category].filter(Boolean).join(" · ")}
                                        </p>
                                    </div>
                                    <ArrowUpRight size={20} className="text-brand-sage opacity-0 group-hover:opacity-100 transition-opacity" />
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            )}
        </div>
    );
}
